import { createPostEndpoint } from '@sonar-software/sonar-http';
import { InitiativeComment } from '@types';

export type PostInitiativeCommentRequest = Omit<InitiativeComment, 'addedOn' | 'addedBy' | 'id'>;

export const postInitiativeComment = createPostEndpoint<PostInitiativeCommentRequest, InitiativeComment>(
	(request) => `/api/v3/initiatives/${request.initiativeId}/comments`
);
